export default "__VITE_ASSET__CRADdGCL__"